import { FC } from 'react';
import Image from '@base/lib/ThemeImage';
import { IReward } from '@pro/common/EggHunt/interface';

type IRewardProductProps = {
    product: IReward['variant'];
};

export const RewardProduct: FC<IRewardProductProps> = props => {
    const { product } = props;

    return (
        <div className={'g-product'}>
            <Image
                className={'g-product-img'}
                src={product.pic}
                width={120}
                background={false}
                fixed
            />
            <div className={'g-product-title'}>
                {product.title}
            </div>
        </div>
    )
};
